import { CRITICALITIES } from '@anirudhm9/base-lib/lib/constants';

const CRITICALITIES_TO_EXCLUDE = [CRITICALITIES.LOW.value, CRITICALITIES.LOW_MEDIUM.value];

export default CRITICALITIES_TO_EXCLUDE;
